<template>
    <ElDialog
        class="modal" 
        :visible.sync="showModal" 
        :width="modalWidth">
        <h2 class="modal__title">
            Успешная оплата!
        </h2>
        <div class="modal__body">
            <p class="modal__text">
                <span v-if="tariffName?.length">
                    Вы оплатили тариф "{{ tariffName }}"
                </span>
                <br>
                Ваш полис на ипотечное страхование успешно оформлен.
            </p>
        </div>
        <div class="modal__submit-buttons">
            <BaseButton text="Закрыть окно" 
                size="large" 
                @click.native="closeModal" />
        </div>
    </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';
import { TARIFFS_TRANSLATIONS_MAP } from "@/consts";

export default {
    name: 'ModalPolicyIssuanceSuccess',
    components: {
        BaseButton
    },
    props: {
        variant: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            tariffName: '',
        }
    },
    mixins: [modal],
    mounted() {
        const { tariff } = this.$route.query;
        this.tariffName = TARIFFS_TRANSLATIONS_MAP[tariff] || ''

    }
}
</script>